export default __webpack_public_path__ + "static/in-person-da1e1f8b723d4862c089bb6944208cce.svg";